"use client";
import React, { useEffect, useRef, useState } from "react";
import SVGIcon from "@/components/SVGIcon";
import { useTranslations } from "next-intl";
import { I18N_NAMESPACE } from "@/config/i18n";
import { INewsViewModel } from "@/fe-core/meta/interfaces/news";
import classNames from "classnames";

type Props = {
  news: INewsViewModel[] | undefined;
};
const NewsBar = ({ news }: Props) => {
  const t = useTranslations(I18N_NAMESPACE.GENERAL);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const textRef = useRef<HTMLDivElement | null>(null);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [duration, setDuration] = useState(80);

  useEffect(() => {
    if (containerRef?.current && textRef?.current) {
      const containerWidth = containerRef?.current?.clientWidth;
      const textWidth = textRef?.current?.scrollWidth;
      const overflow = textWidth > containerWidth;
      setShouldAnimate(overflow);

      if (overflow) {
        const speedFactor = 40;
        setDuration(textWidth / speedFactor);
      }
    }
  }, [news]);

  if (!news || news?.length === 0) return <></>;

  return (
    <div className="bg-tertiary-300 flex items-center text-xs">
      <div className="flex items-center gap-2 text-primary py-2 px-2 bg-tertiary-300">
        <SVGIcon icon={"news"} className="w-4.5 h-4.5" />
        <p className="font-bold">{t("news-label")}</p>
      </div>

      <div className="overflow-hidden whitespace-nowrap" ref={containerRef}>
        <div
          ref={textRef}
          className={classNames("inline-block text-nowrap text-[#868686]", {
            "animate-marquee": shouldAnimate,
          })}
          style={{ animationDuration: `${duration}s` }}
        >
          {news
            ?.map((newsItem, index) => newsItem?.attributes?.title)
            .join(" | ")}
        </div>
      </div>
    </div>
  );
};

export default NewsBar;
